// German (Deutsch)
export default {
  nav: {
    home: 'Startseite',
    wall: 'Die Pinnwand',
    groups: 'Gruppen',
    users: 'Benutzer',
    profile: 'Mein Profil',
    help: 'Hilfe',
    membership: 'Mitgliedschaft',
    logout: 'Abmelden',
    login: 'Anmelden'
  },
  auth: {
    loginSubtitle: 'Melden Sie sich an, um fortzufahren',
    email: 'E-Mail',
    password: 'Passwort',
    noAccount: 'Noch kein Konto?',
    createAccount: 'Konto erstellen',
    loginFailed: 'Anmeldung fehlgeschlagen. Überprüfen Sie E-Mail und Passwort.',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    register: 'Registrieren',
    name: 'Name',
    confirmPassword: 'Passwort bestätigen',
    registrationSuccess: 'Konto erstellt! Sie können sich jetzt anmelden.',
    registrationFailed: 'Konto konnte nicht erstellt werden.'
  },
  home: {
    title: 'Gemeinschaft',
    tagline: 'Ein ruhiger Ort im Internet – ohne Werbung.',
    description: 'Teilen Sie den Alltag mit Familie, Freunden und neuen Bekannten. Kein Lärm, kein Tracking, kein Datenverkauf.',
    features: {
      noAds: 'Werbefrei',
      simple: 'Einfach und klar',
      safe: 'Sichere Atmosphäre + Moderation'
    },
    cta: {
      openWall: 'Pinnwand öffnen',
      createProfile: 'Kostenloses Profil erstellen',
      goToWall: 'Zur Pinnwand',
      readMore: 'Mehr über die Idee'
    },
    pricing: 'Die Seite ist kostenlos.',
    pricingDetail: 'Aber auch wir müssen leben – bitte erwägen Sie zu spenden.'
  },
  wall: {
    title: 'Die Pinnwand',
    subtitle: 'Hier sehen Sie Beiträge aus der Gemeinschaft.',
    writePost: 'AN DIE PINNWAND SCHREIBEN',
    placeholder: 'Schreiben Sie Ihren Beitrag hier...',
    group: 'Gruppe',
    noGroup: 'Keine Gruppe',
    selectImage: 'Bild auswählen',
    noFileSelected: 'Keine Datei ausgewählt.',
    send: 'Senden',
    public: 'Öffentlich',
    members: 'Mitglieder',
    private: 'Privat',
    visibility: 'Sichtbarkeit'
  },
  groups: {
    title: 'Gruppen',
    subtitle: 'Gruppen, die Sinn machen – lokal, Hobbys, Reisen, Spaziergänge – einfach zu folgen.',
    createGroup: 'Gruppe erstellen',
    allGroups: 'Alle Gruppen',
    myGroups: 'Meine Gruppen',
    searchPlaceholder: 'Gruppen suchen...',
    noGroups: 'Keine Gruppen gefunden',
    noMyGroups: 'Sie sind noch kein Mitglied einer Gruppe',
    groupName: 'Gruppenname',
    description: 'Beschreibung',
    publicGroup: 'Öffentliche Gruppe (alle können sehen und beitreten)',
    private: 'Privat',
    createdBy: 'Erstellt von',
    members: 'Mitglieder',
    postsCount: 'Beiträge',
    noDescription: 'Keine Beschreibung',
    join: 'Beitreten',
    leave: 'Verlassen',
    open: 'Öffnen',
    leaveConfirm: 'Sind Sie sicher, dass Sie diese Gruppe verlassen möchten?',
    postsTab: 'Beiträge',
    membersTab: 'Mitglieder',
    noPosts: 'Noch keine Beiträge in dieser Gruppe',
    joinToSee: 'Treten Sie der Gruppe bei, um Beiträge zu sehen',
    about: 'Über die Gruppe',
    createdOn: 'Erstellt',
    editGroup: 'Gruppe bearbeiten',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Gruppe löschen möchten? Alle Beiträge werden gelöscht.',
    setMember: 'Als Mitglied setzen',
    setModerator: 'Als Moderator setzen',
    setAdmin: 'Als Admin setzen',
    removeMember: 'Aus Gruppe entfernen',
    removeMemberConfirm: 'Sind Sie sicher, dass Sie {name} aus der Gruppe entfernen möchten?',
    changeCover: 'Titelbild ändern',
    invalidImageType: 'Ungültiger Dateityp. Bitte wählen Sie ein Bild.',
    imageTooLarge: 'Das Bild ist zu groß. Maximal 5MB.'
  },
  profile: {
    title: 'Mein Profil',
    editProfile: 'Profil bearbeiten',
    myPosts: 'Meine Beiträge',
    myGroups: 'Meine Gruppen',
    overview: 'Übersicht',
    edit: 'Bearbeiten',
    settings: 'Einstellungen',
    activity: 'Aktivität',
    bio: 'Über mich',
    location: 'Standort',
    website: 'Webseite',
    birthday: 'Geburtstag',
    interests: 'Interessen',
    joined: 'Beigetreten',
    posts: 'Beiträge',
    comments: 'Kommentare',
    reactions: 'Reaktionen',
    privacy: 'Datenschutz',
    showRealName: 'Echten Namen öffentlich zeigen',
    showEmail: 'E-Mail öffentlich zeigen',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    uploadAvatar: 'Profilbild hochladen',
    changeAvatar: 'Profilbild ändern',
    removeAvatar: 'Profilbild entfernen',
    bioPlaceholder: 'Erzählen Sie etwas über sich...',
    interestsPlaceholder: 'Was interessiert Sie?',
    saveChanges: 'Änderungen speichern',
    cancelChanges: 'Abbrechen',
    profileUpdated: 'Profil aktualisiert!',
    passwordChanged: 'Passwort geändert!',
    avatarUploaded: 'Profilbild hochgeladen!',
    recentPosts: 'Neueste Beiträge',
    recentComments: 'Neueste Kommentare',
    recentReactions: 'Neueste Reaktionen',
    noPosts: 'Noch keine Beiträge',
    noComments: 'Noch keine Kommentare',
    noReactions: 'Noch keine Reaktionen',
    downloadData: 'Meine Daten herunterladen',
    deleteAccount: 'Konto löschen',
    deleteAccountWarning: 'Dies wird Ihr Konto und alle Daten dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    age: 'Jahre alt'
  },
  common: {
    loading: 'Laden...',
    error: 'Ein Fehler ist aufgetreten',
    success: 'Erfolgreich!',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    post: 'Senden',
    comment: 'Kommentar',
    quote: 'Zitieren',
    reply: 'Antworten',
    confirm: 'Bestätigen',
    ok: 'OK',
    data: 'Daten',
    noComments: 'Noch keine Kommentare. Seien Sie der Erste!',
    writeComment: 'Einen Kommentar schreiben...',
    replyToComment: 'Auf Kommentar antworten...',
    deleteConfirm: 'Diesen Beitrag löschen?',
    contentRequired: 'Der Inhalt darf nicht leer sein',
    updateFailed: 'Beitrag konnte nicht aktualisiert werden',
    deleteFailed: 'Beitrag konnte nicht gelöscht werden',
    commentFailed: 'Kommentar konnte nicht gesendet werden'
  },
  users: {
    searchTitle: 'Benutzer finden',
    searchSubtitle: 'Suchen Sie nach Benutzern in der Gemeinschaft',
    searchPlaceholder: 'Suchen nach Benutzername, Name oder E-Mail...',
    search: 'Suchen',
    searchHint: 'Geben Sie mindestens 2 Zeichen ein, um nach Benutzern zu suchen',
    resultsFound: '{count} Benutzer gefunden',
    noResults: 'Keine Benutzer gefunden. Versuchen Sie einen anderen Suchbegriff.'
  },
  validation: {
    required: 'Dieses Feld ist erforderlich',
    email: 'Geben Sie eine gültige E-Mail-Adresse ein',
    maxLength: 'Maximal {max} Zeichen',
    passwordMatch: 'Die Passwörter müssen übereinstimmen'
  }
}
